// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-list[data-v-3c405032] {\n    height: auto;\n    max-height: 70vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    width: 600px;\n}\n.notifications[data-v-3c405032] {\n    border-radius: 1rem;\n    font-size: 11px;\n    position: absolute;\n    top: -10px;\n    right: -3px;\n    width: 24px;\n    height: 14px;\n    padding: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
